import {media} from '@/styles/recipeMq';
import useMediaQuery from './useMediaQuery';

const useIsTabletOrDesktopCheck = (): boolean => {
  return useMediaQuery(`${media.medium}`);
};

export default useIsTabletOrDesktopCheck;
